import { render } from "./ticket_details.vue?vue&type=template&id=7b45cb42&scoped=true"
import script from "./ticket_details.vue?vue&type=script&lang=js"
export * from "./ticket_details.vue?vue&type=script&lang=js"

import "./ticket_details.vue?vue&type=style&index=0&id=7b45cb42&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b45cb42"]])

export default __exports__